// Simple sponsorship registry with location-aware entries
// Keys are normalized: "city:{citySlug},{stateSlug}" or "state:{stateSlug}" or "global"
// This is a basic starter config; in production this can be replaced with a CMS/remote source
export const sponsorshipRegistry = {
  // City-level examples
  "city:seattle,wa": {
    id: "spn-seattle-wa-001",
    enabled: false,
    logoUrl: "/images/sponsors/sample-logo-sea.png",
    headline: "Seattle's Premier STEM Summer Experience",
    blurb: "Hands-on robotics, coding, and AI projects designed for curious young minds.",
    ctaText: "Explore Seattle Programs",
    ctaHref: "https://example.com/seattle",
    bgImageUrl: "/images/sponsors/sample-bg-sea.jpg",
    disclosure: "Sponsored"
  },
  // State-level examples
  "state:wa": {
    id: "spn-wa-001",
    enabled: false,
    logoUrl: "/images/sponsors/sample-logo-wa.png",
    headline: "Washington's Top-Rated Outdoor Camps",
    blurb: "Adventure, leadership, and lifelong friendships among the pines.",
    ctaText: "See Washington Camps",
    ctaHref: "https://example.com/washington",
    bgImageUrl: "/images/sponsors/sample-bg-wa.jpg",
    disclosure: "Sponsored"
  },
  // Global fallback
  "global": {
    id: "spn-global-001",
    enabled: false,
    logoUrl: "/images/sponsors/sample-logo-global.png",
    headline: "Discover Amazing Summer Camps Near You",
    blurb: "Find programs that match your family's interests, schedule, and budget.",
    ctaText: "Start Exploring",
    ctaHref: "https://mysummersquad.com/Discovery",
    bgImageUrl: "/images/sponsors/sample-bg-global.jpg",
    disclosure: "Sponsored"
  }
};

export function normalizeSlug(value) {
  return String(value || "")
    .trim()
    .toLowerCase()
    .replace(/\s+/g, "-")
    .replace(/[^a-z0-9\-]/g, "");
}

export function resolveSponsorForLocation(cityName, stateCode) {
  const citySlug = normalizeSlug(cityName);
  const stateSlug = normalizeSlug(stateCode);

  // Priority: city -> state -> global
  const cityKey = citySlug && stateSlug ? `city:${citySlug},${stateSlug}` : null;
  const stateKey = stateSlug ? `state:${stateSlug}` : null;

  const byCity = cityKey ? sponsorshipRegistry[cityKey] : null;
  if (byCity && byCity.enabled) return { sponsor: byCity, tier: "city" };

  const byState = stateKey ? sponsorshipRegistry[stateKey] : null;
  if (byState && byState.enabled) return { sponsor: byState, tier: "state" };

  const global = sponsorshipRegistry["global"];
  if (global && global.enabled) return { sponsor: global, tier: "global" };

  return { sponsor: null, tier: "none" };
}


